import { render, staticRenderFns } from "./mtab.vue?vue&type=template&id=d49dda08&scoped=true"
import script from "./mtab.vue?vue&type=script&lang=js"
export * from "./mtab.vue?vue&type=script&lang=js"
import style0 from "./mtab.vue?vue&type=style&index=0&id=d49dda08&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49dda08",
  null
  
)

export default component.exports